import { selectFavouriteVideoIds, mapIsFavouriteVideos } from 'logic/favourite';
import { fetchWorkoutVideo, selectWorkoutVideo } from 'logic/workout';

export const WorkoutsVideo = {
  template: `
    <div class="workouts-video bg-white">
      <nav-page>
        <nav-left>
          <button-back></button-back>
        </nav-left>
      </nav-page>
      <main class="main-content">
        <div class="container pt-4">
          <h3 class="mb-3">{{ $ctrl.video.title }}</h3>
          <div class="row">
            <div class="col-lg-8">
              <ul class="list-unstyled d-flex justify-content-between p-3 m-0 bg-gray-100 small font-size-sm-base workout-meta">
                <li ng-if="$ctrl.video.equipmentRequired">
                  Equipment required
                </li>
                <li ng-if="$ctrl.video.met">
                  <i class="fa fa-lg icon-calories-burnt text-green-dark"></i>
                  <workout-calories-burnt
                    member="$ctrl.member"
                    met="$ctrl.video.met"
                    total-time="$ctrl.video.totalTimeInSeconds">
                  </workout-calories-burnt> Cal
                </li>
                <li>
                  <i class="fa fa-lg icon-time text-green-dark"></i>
                  {{ $ctrl.video.time }} mins
                </li>
                <li ng-if="$ctrl.video.location">
                  <i class="fa fa-lg icon-location text-green-dark"></i>
                  {{ $ctrl.video.location }}
                </li>
                <li ng-if="$ctrl.video.isFavourite">
                  <i class="fa fa-lg icon-favourites text-green-dark"></i>
                  Favourite
                </li>
              </ul>
            </div>
            <div class="col-lg-4">
              <ul class="list-unstyled p-3 m-0 bg-gray-100 small font-size-sm-base workout-meta">
                <li class="d-flex justify-content-between">
                  <span>Member Rating:</span>
                  <rating-stars
                    rating="$ctrl.video.averageRating"
                    size="md">
                  </rating-stars>
                </li>
              </ul>
            </div>
          </div>
          <div class="pt-3 pb-5">
            <video-playlist
              list="$ctrl.video.items"
              autoplay="false"
              continuous="true"
              loop="false">
              <p>{{ $ctrl.video.description }}</p>
            </video-playlist>
          </div>
          <div class="row mb-4">
            <div class="col-lg-8" ng-if="$ctrl.video">
              <reviews
                wording-plural="Reviews"
                wording-rating="Rate this video"
                wording-singular="Review"
                reviewable-type="PlaylistVideo"
                reviewable-id="$ctrl.video.id">
              </reviews>
            </div>
          </div>
        </div>
      </main>
    </div>`,

  controller($ngRedux) {
    'ngInject';

    return {
      $onInit() {
        const connect = $ngRedux.connect(this.mapState, this.mapDispatch());
        this.disconnect = connect(this);

        if (!this.video || !this.video.items) {
          this.fetchWorkoutVideo(this.videoId);
        }
      },

      $onDestroy() {
        this.disconnect();
      },

      mapState({ router, workout, favourite }) {
        const { videoId } = router.currentParams;
        const { isLoading } = workout;

        return {
          videoId,
          isLoading,
          video: mapIsFavouriteVideos(
            selectWorkoutVideo(workout, videoId),
            selectFavouriteVideoIds(favourite)
          ),
        };
      },

      mapDispatch() {
        return {
          fetchWorkoutVideo,
        };
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/containers/Workouts/Video.js